import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import Modal from '../Modal'
import * as s from './ModalDownloadPresentation.module.scss'
import Typography from '../Typography'
import DownloadIcon from '../../../svg/download-icon'

interface ModalDownloadPresentationProps {
  title: string
  presentationData: {
    fileUrl: string
    title: string
    image: IGatsbyImageData
    imageTitle?: string
  }[]
  onClose: () => void
}

const ModalDownloadPresentation: React.FC<ModalDownloadPresentationProps> = ({
  title,
  presentationData,
  onClose,
}) => {
  const onDownloadFile = (fileUrl: string) => {
    const link = document.createElement('a')
    link.href = fileUrl
    link.setAttribute('download', '')
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
  }

  return (
    <Modal contentClassName={s.content} onClose={onClose} title={title}>
      <div className={s.items}>
        {presentationData.map((item, idx) => (
          <div
            key={idx}
            className={s.item}
            onClick={() => onDownloadFile(item.fileUrl)}
          >
            <div className={s.image}>
              <GatsbyImage
                image={item.image}
                alt={item.imageTitle || item.title}
                title={item.imageTitle || item.title}
                imgStyle={{
                  objectFit: 'contain',
                  objectPosition: '50% 50%',
                  borderRadius: '2px',
                }}
              />
            </div>
            <div className={s.download}>
              <Typography variant="body2" className={s.download_title}>
                {item.title}
              </Typography>
              <span className={s.icon}>
                <DownloadIcon />
              </span>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  )
}

export default ModalDownloadPresentation
